import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.declined_view.title',
        defaultMessage: 'Sorry, we can’t approve your application today.'
    },
    description: {
        id: '_.declined_view.description',
        defaultMessage:
            'If you’d like to speak to us about the decision, or if you have any questions, give us a ring on {phoneNumber}.'
    },
    reApplyButtonText: {
        id: '_.declined_view.reApplyButtonText',
        defaultMessage: 'Apply'
    },
    reapplyTitle: {
        id: '_.declined_view.reapply_title',
        defaultMessage: 'Welcome back, {name}'
    },
    reapplyDescription: {
        id: '_.declined_view.reapply_description',
        defaultMessage:
            'Looking to apply for funds? Click the button below to get started, or if you have any questions, give us a ring on {phoneNumber}'
    }
});
